import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/css/style.css";

// ================== IDLE LOGOUT ==================
const IDLE_TIME = 4 * 60 * 60 * 1000;

function updateLastActivity() {
  localStorage.setItem("lastActivity", Date.now());
}

["click", "mousemove", "keydown", "scroll", "touchstart"].forEach((event) => {
  window.addEventListener(event, updateLastActivity);
});

setInterval(() => {
  const lastActivity = localStorage.getItem("lastActivity");
  const token = localStorage.getItem("token");

  if (!token) return;

  if (lastActivity) {
    const diff = Date.now() - parseInt(lastActivity);

    if (diff > IDLE_TIME) {
      console.log("Idle 4 hours → logout");

      localStorage.removeItem("token");
      localStorage.removeItem("lastActivity");

      window.location.href = "/login";
    }
  }
}, 60 * 1000);

updateLastActivity();

const app = createApp(App);
app.use(router);
app.mount("#app");
